import script from "./TheLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./TheLogin.vue?vue&type=script&setup=true&lang=js"

import "./TheLogin.vue?vue&type=style&index=0&id=6b639378&scoped=true&lang=css"

import exportComponent from "F:\\paratech\\al-sharaf\\new-admin\\al_sharaf_admin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b639378"]])

export default __exports__